var map = {
	"./apple_music.png": "vKt7",
	"./deezer.png": "FiqH",
	"./itunes.png": "bxaa",
	"./play_music.png": "XuDz",
	"./spotify.png": "mxe+",
	"./yandex_music.png": "oFmu",
	"./youtube_music.png": "01Vm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q+kD";